import styled from 'styled-components';
import { rem } from 'polished';
import { prefix } from '../../tools/settings';
var SummaryBar = styled.div.withConfig({
  displayName: "SummaryBarstyles__SummaryBar",
  componentId: "sc-1c0ujr5-0"
})(["display:flex;justify-content:space-between;border:1px solid var(--dentsu-color-n300);margin-bottom:", ";background:var(--dentsu-color-n25);padding:", " ", ";font-size:var(--dentsu-font-size-12);line-height:", ";&.", "-summary-bar--actions{padding:", " ", " ", " ", ";.", "-summary-bar__content{max-width:75%;}}"], rem(28), rem(8), rem(24), rem(16), prefix, rem(8), rem(8), rem(4), rem(24), prefix);
var SummaryBarContent = styled.div.attrs({
  className: "".concat(prefix, "-summary-bar__content")
}).withConfig({
  displayName: "SummaryBarstyles__SummaryBarContent",
  componentId: "sc-1c0ujr5-1"
})(["padding:", " ", " ", " 0;*{font-size:var(--dentsu-font-size-12);line-height:", ";}"], rem(8), rem(40), rem(8), rem(16));
var SummaryBarActions = styled.div.withConfig({
  displayName: "SummaryBarstyles__SummaryBarActions",
  componentId: "sc-1c0ujr5-2"
})(["text-align:right;white-space:nowrap;"]);
export var Styled = {
  SummaryBar: SummaryBar,
  SummaryBarContent: SummaryBarContent,
  SummaryBarActions: SummaryBarActions
};